import i18n from '@/i18n'

export const getRelevantUrlComponent = (url) => {
  const pathComponents = url.split('/')
  const lastComponent = pathComponents[pathComponents.length - 1]

  // Check if the last component is a GUID or Integer
  const guidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const lastComponentOffset = guidPattern.test(lastComponent) || !isNaN(parseInt(lastComponent))
    ? 2 : 1

  let relevantComponent = pathComponents[pathComponents.length - lastComponentOffset].toLowerCase()

  if (relevantComponent.charAt(relevantComponent.length - 1) === 's' && !singularsEndingInS.includes(lastComponent)) {
    relevantComponent = relevantComponent.slice(0, -1)
  }

  return renameDictionary[relevantComponent] || relevantComponent
}

const renameDictionary = {
  tracttype: i18n.t('tractType'),
  tractpayable: i18n.t('tractPayable'),
  tractcontent: i18n.t('cruiseData'),
  tractharvest: i18n.t('tractHarvest'),
  journalentrie: i18n.t('accrual'),
  ticketexport: i18n.t('ticketExport'),
  defectdefinition: i18n.t('defectDefinition'),
  businessentitie: i18n.t('entity'),
  timeinyard: i18n.t('timeInYard'),
  tractdeliveredcost: i18n.t('deliveredTractCosts'),
  ticketsummarie: i18n.t('ticketSummaries'),
  harvestbyregion: i18n.t('harvestByRegion'),
  deviceregistrations: i18n.t('deviceRegistrations'),
  applicationuser: i18n.t('user'),
  ticketfinancialrecoveriesexport: i18n.t('financialRecoveryExport'),
  ticketfinancialsexport: i18n.t('financialExport'),
  ticketimage: i18n.t('ticketImage'),
  companyinfo: i18n.t('companyInfo'),
  servertime: i18n.t('serverTime'),
  activitytemplate: i18n.t('activityTemplate'),
  recoverie: i18n.t('recovery'),
  activitydetail: i18n.t('activityDetail'),
  activitie: i18n.t('activity'),
  userpreference: i18n.t('userPreferences'),
  millinfo: i18n.t('millInformation'),
  consumptionbatche: i18n.t('consumptionBatch'),
  postbatche: i18n.t('postBatch'),
  jecsvexport: i18n.t('accrualCsvExport'),
  arcsvexport: i18n.t('receivableCsvExport'),
  apcsvexport: i18n.t('payableCsvExport'),
  tractpayment: i18n.t('tractPayment'),
  journalentrycalculation: i18n.t('accrualCalculations'),
  journalentryregister: i18n.t('accrualRegister'),
  receivableregister: i18n.t('receivableRegister'),
  arproductionsummary: i18n.t('receivableProductionSummary'),
  producerproduction: i18n.t('producerProduction'),
  ticketregister: i18n.t('ticketRegister'),
  paymentregister: i18n.t('paymentRegister'),
  payperiod: i18n.t('payPeriod'),
  fiscalyear: i18n.t('fiscalYear'),
  addresse: i18n.t('address'),
  diameterweight: i18n.t('diameterWeights'),
  modification: i18n.t('advanceModification'),
  activitytemplatedetail: i18n.t('templateDetail'),
  exportbatche: i18n.t('exportBatch'),
  activitybuilder: i18n.t('activityBuilder'),
  accountpayable: i18n.t('accountPayment'),
  insurancepolicie: i18n.t('insurancePolicy'),
  receiversetting: i18n.t('receiverSettings'),
  deviceregistration: i18n.t('deviceRegistration'),
  accountpayabletemplate: i18n.t('accountPayableTemplate'),
  penaltydefinition: i18n.t('penaltyDefinition'),
  penaltythreshold: i18n.t('penaltyThreshold'),
  harvesttype: i18n.t('harvestType'),
  loggingmethod: i18n.t('loggingMethod'),
  settlementverification: i18n.t('settlementVerification'),
  ticketbook: i18n.t('ticketBook'),
  contractproduct: i18n.t('contractProducts'),
  endUseSort: i18n.t('endUseSort'),
  loglength: i18n.t('logLength'),
  lengthgroup: i18n.t('lengthGroup'),
  diametergroup: i18n.t('diameterGroup'),
  speciesgroup: i18n.t('speciesGroup'),
  ratesheetdefinition: i18n.t('rateSheetDefinition'),
  versionedrate: i18n.t('versionedRate'),
  endusesort: i18n.t('endUseSort'),
  scheduledratechange: i18n.t('scheduledRateChange'),
  scalesheetprofile: i18n.t('scaleSheetProfile'),
  volumedata: i18n.t('volumeData'),
  yardinstruction: i18n.t('yardInstruction'),
  driverslicense: i18n.t('driversLicense'),
  driverdetail: i18n.t('driverDetail'),
  tractgroup: i18n.t('tractGroup'),
  namedrate: i18n.t('namedRate'),
  timbercategorie: i18n.t('timberCategory'),
  landownertype: i18n.t('landownerType'),
  bidcosttype: i18n.t('bidCostType'),
  conversion: i18n.t('conversion'),
  mitigationitem: i18n.t('mitigationItem'),
  tractvisittype: i18n.t('visitType')
}

const singularsEndingInS = ['species']
